import React from 'react';
import { Globe } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const AdminReports: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Admin Reports</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Generate and view administrative reports for your dashboard
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        <div className="card-modern p-6 space-y-3">
          <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
            <Globe className="h-5 w-5" />
          </div>
          <h3 className="font-semibold">Domain Report</h3>
          <p className="text-sm text-muted-foreground">
            View domain orders and email statistics by date range
          </p>
          <button 
            onClick={() => navigate('/domain-order-reports')}
            className="btn-primary px-4 py-2 rounded-lg text-sm font-medium w-full mt-4"
          >
            View Report
          </button>
        </div>
      </div>

      <div className="card-modern p-8 text-center">
        <p className="text-muted-foreground">
          More report types coming soon...
        </p>
      </div>
    </div>
  );
}; 